import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { adminService, publicService, casdoorAuthService, mainService, teachbaseService } from '@/api/services';

// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.
const rootReducer = combineSlices(adminService, publicService, mainService, casdoorAuthService, teachbaseService);
// Infer the `RootState` type from the root reducer
export type TRootState = ReturnType<typeof rootReducer>;

// The store setup is wrapped in `makeStore` to allow reuse
// when setting up tests that need the same store config
export const makeStore = (preloadedState?: Partial<TRootState>) => {
  const store = configureStore({
    reducer: rootReducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
      // eslint-disable-next-line unicorn/prefer-spread
      getDefaultMiddleware().concat(
        adminService.middleware,
        publicService.middleware,
        mainService.middleware,
        casdoorAuthService.middleware,
        teachbaseService.middleware,
      ),
    preloadedState,
  });
  // configure listeners using the provided defaults
  // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
  setupListeners(store.dispatch);
  return store;
};

export type TAppStore = ReturnType<typeof makeStore>;

export type TAppDispatch = TAppStore['dispatch'];
